import DashboardComponent from 'modules/general/components/DashboardComponent';

const DashboardContainer = () => <DashboardComponent />;

export default DashboardContainer;
